module.exports = __webpack_public_path__ + "static/img/aa-10.4a8c79e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aa-10.png
// module id = xewJ
// module chunks = 1